import * as React from "react";

export interface AgGridTableTooltipOnHeaderResultProps {
    tableNode: HTMLDivElement;
    query: string;
    className: string;
}

export default function AgGridTableTooltipOnHeaderResult(props: AgGridTableTooltipOnHeaderResultProps) {
    const { query } = props;
    const cellLabelNode = props.tableNode.querySelector(query) as HTMLSpanElement;
    if (!cellLabelNode || cellLabelNode.clientWidth >= cellLabelNode.scrollWidth) {
        return null;
    }
    return (
        <div className={props.className}> 
            <p><b>{cellLabelNode.textContent}</b></p>
        </div> 
    );
}